import { cn } from '@/shared/lib/utils'

interface TremorLogoProps {
  size?: number
  className?: string
  /** Show the rounded onyx background rect (for standalone icon use) */
  withBackground?: boolean
}

/**
 * TremorApp official logo — concentric wave arcs radiating right.
 * Based on icon-32-onyx.svg brand asset.
 */
export function TremorLogo({ size = 28, className, withBackground = false }: TremorLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={cn('flex-shrink-0', className)}
    >
      {withBackground && <rect width="32" height="32" rx="7" fill="#1C1810" />}
      <circle cx="11" cy="16" r="2.5" fill="currentColor" />
      <path
        d="M11,11 A5,5 0 0,1 11,21"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M11,8 A8,8 0 0,1 11,24"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        fill="none"
        opacity="0.5"
      />
      <path
        d="M11,5 A11,11 0 0,1 11,27"
        stroke="currentColor"
        strokeWidth="0.9"
        strokeLinecap="round"
        fill="none"
        opacity="0.22"
      />
    </svg>
  )
}
